import { css, cx, keyframes } from "@emotion/css";
import { themeTokens, borderRadius } from "@octopusdeploy/design-system-tokens";
export type BeaconSizeType = "small" | "medium";
export interface BeaconBaseProps {
    size?: BeaconSizeType;
    ripple?: number;
    onClick?: () => void;
}
export function BeaconBase({ size = "medium", ripple = 0.75, onClick }: BeaconBaseProps) {
    const outerRingKeyframes = createOuterRingKeyframes(ripple);
    const onBeaconClicked = () => {
        onClick?.();
    };
    return (<button onClick={onBeaconClicked} className={cx(beaconStyles.container, sizeStyles.container[size])}>
            <span className={cx(beaconStyles.beaconInner, sizeStyles.beaconInner[size])}/>
            <span className={beaconStyles.beaconOuter} style={{
            animation: `${outerRingKeyframes} 1.2s ease-in-out infinite`,
        }}/>
        </button>);
}
const createOuterRingKeyframes = (ripple: number) => keyframes({
    "0%": {
        transform: "scale(1)",
    },
    "45%": {
        transform: `scale(${ripple})`,
    },
    "100%": {
        transform: "scale(1)",
    },
});
const beaconStyles = {
    container: css({
        position: "relative",
        cursor: "pointer",
        background: "none",
        border: "none",
    }),
    beaconInner: css({
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        display: "block",
        borderRadius: borderRadius.circle,
        backgroundColor: themeTokens.color.icon.info,
    }),
    beaconOuter: css({
        position: "absolute",
        width: "100%",
        height: "100%",
        left: "0",
        top: "0",
        display: "block",
        borderRadius: borderRadius.circle,
        border: `2px solid ${themeTokens.color.icon.info}`,
        backgroundColor: themeTokens.color.button.background.tertiary.pressed,
        transformOrigin: "center center",
        boxSizing: "border-box",
    }),
};
const sizeStyles = {
    container: {
        small: css({
            width: 20,
            height: 20,
        }),
        medium: css({
            width: 32,
            height: 32,
        }),
    },
    beaconInner: {
        small: css({
            width: 10,
            height: 10,
        }),
        medium: css({
            width: 14,
            height: 14,
        }),
    },
};
